import { Box, TablePagination } from '@mui/material';

interface GridPaginationProps {
  count: number;
  isLoading: boolean;
  page: number;
  perPage: number;
  handlePageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  handleRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const GridPagination = ({
  count,
  isLoading,
  page,
  perPage,
  handlePageChange,
  handleRowsPerPageChange,
}: GridPaginationProps) => {
  return (
    <Box
      sx={(t) => ({
        p: 2,
        height: 54,
        minHeight: 54,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        gap: 1,
        borderTop: `1px solid ${t.palette.divider}`,
        cursor: 'default',
      })}
    >
      <TablePagination
        disabled={isLoading}
        labelRowsPerPage="Rows per page:"
        component="div"
        count={count}
        page={page - 1}
        onPageChange={(event, newPage) => {
          handlePageChange(event, newPage + 1);
        }}
        rowsPerPage={perPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={[25, 50, 100]}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexGrow: 1,
          minHeight: 54,
          maxHeight: 54,
          backgroundColor: 'white',
        }}
      />
    </Box>
  );
};
